module.exports = __webpack_public_path__ + "static/media/team_building.8b2002ed.svg";